/** @jsxImportSource react */
import FieldAdapter from '@react/form/components/FieldAdapter';
import { required } from '@react/form/helpers/validation';
import { ADL_OPTIONS_MAP } from '@react/gwizzy/constants';
import { Button } from '@react/system';
import {
  MOBILITY_OPTIONS,
  ROOM_OPTIONS,
} from '@react/widgets/pricingCalculator/constants';
import React from 'react';
import { Field, Form } from 'react-final-form';

const PricingCalculator = ({
  handleSubmit,
  initialFilters,
  locationString,
  submitButtonClassName = '',
  submitButtonVariant = 'outlined',
  eventProps = {},
}) => {
  return (
    <div className='rounded px-4 py-5 shadow'>
      <Form
        keepDirtyOnReinitialize
        onSubmit={handleSubmit}
        initialValues={initialFilters}
      >
        {({ handleSubmit, submitting, invalid, values }) => {
          return (
            <form
              onSubmit={handleSubmit}
              data-tp-id='gen-form-2be9dba3-a4d6-4560-bb91-85d01e98c532'
            >
              <div className='grid gap-4 md:grid-cols-2'>
                <Field
                  name='location'
                  component={FieldAdapter}
                  type='locationSearch'
                  label='City name'
                  data-tp-id='gen-Field-af18addc-1624-4349-af1f-7e3ac94364ba'
                  validate={required}
                  types={['(cities)']}
                  placeholder='Search by city'
                  address={locationString}
                />
                <Field
                  name='careLevel'
                  component={FieldAdapter}
                  type='select'
                  label='Care needs'
                  data-tp-id='gen-Field-af18addc-1624-4349-af1f-7e3ac94364ba'
                  validate={required}
                  options={Object.values(ADL_OPTIONS_MAP)}
                />
              </div>

              <div className='grid gap-4 md:grid-cols-2'>
                <Field
                  name='typeOfRoom'
                  component={FieldAdapter}
                  type='segmented'
                  label='Room Type'
                  data-tp-id='gen-Field-af18addc-1624-4349-af1f-7e3ac94364ba'
                  validate={required}
                  defaultValue={ROOM_OPTIONS[0].value}
                  options={ROOM_OPTIONS}
                />
                <Field
                  name='mobility'
                  component={FieldAdapter}
                  type='select'
                  label='Mobility'
                  data-tp-id='gen-Field-af18addc-1624-4349-af1f-7e3ac94364ba'
                  validate={required}
                  defaultValue={MOBILITY_OPTIONS[0].value}
                  options={MOBILITY_OPTIONS}
                  className='md:[&_.input-wrapper]:!h-full'
                />
              </div>

              <div
                className='p-3 md:p-0'
                data-tp-id='gen-div-33181c6c-70e1-47df-9894-4524d8e4677d'
              >
                <Button
                  eventProps={{
                    location: 'cost of care calculator',
                    // pathname: isServer window?.location?.pathname,
                    filters: {
                      toc: values?.toc,
                      typeOfRoom: values?.typeOfRoom,
                      city: values?.location?.searchParams?.city,
                    },
                    ...eventProps,
                  }}
                  onClick={() => handleSubmit(values)}
                  type='button'
                  disabled={submitting || invalid}
                  variant={submitButtonVariant}
                  className={submitButtonClassName}
                  data-tp-id='gen-Button-cb53f138-bb5f-4675-a94e-cf922c046697'
                >
                  Calculate
                </Button>
              </div>
            </form>
          );
        }}
      </Form>
    </div>
  );
};

export default PricingCalculator;
